import SwipeIn from './SwipeIn';
export default SwipeIn;